module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_RU.bc1ed87a.txt";